// removed by extract-text-webpack-plugin
module.exports = {"theme":"#000"};


//////////////////
// WEBPACK FOOTER
// ./src/assets/scss/element-variables.scss
// module id = zMOa
// module chunks = 6